// 荣誉
import service from "@/utils/request";

/**
 * @description 荣誉列表
 * @param {Object} data - 荣誉列表参数
 * @param {number} data.page - 当前页
 * @param {number} data.pageSize：每页数量 - 每页数量
 * @returns {Promise} - 荣誉列表结果
*/
export function getWallHonorList(data) {
  return service({
    url: "/service/admin/honor/list",
    method: "get",
    params: data,
  });
}

/**
 * @description 荣誉详情
 * @param {Object} data - 荣誉详情参数
 * @param {number} data.id：荣誉ID - 荣誉ID
 * @returns {Promise} - 荣誉详情结果
*/
export function getWallHonorDetail(data) {
  return service({
    url: "/service/admin/honor/info",
    method: "get",
    params: data,
  });
}



/**
 * @description 荣誉新增
 * @param {Object} data - 荣誉新增参数
 * @param {string} data.title：标题 - 荣誉名称
 * @param {string} data.bgm：图片 - 荣誉描述
 * @param {string} data.label_color：描述字体颜色 - 描述字体颜色
 * @param {string} data.value_color：数据字体颜色 - 数据字体颜色
 * @returns {Promise} - 荣誉新增结果
*/
export function addWallHonor(data) {
  return service({
    url: "/service/admin/honor/create",
    method: "post",
    data,
  });
}

/**
 * @description 荣誉编辑
 * @param {Object} data - 荣誉编辑参数
 * @param {number} data.id：荣誉ID - 荣誉ID
 * @param {string} data.title：标题 - 荣誉名称
 * @param {string} data.bgm：图片 - 荣誉描述
 * @param {string} data.label_color：描述字体颜色 - 描述字体颜色
 * @param {string} data.value_color：数据字体颜色 - 数据字体颜色
 * @returns {Promise} - 荣誉编辑结果
 */
export function editWallHonor(data) {
  return service({
    url: "/service/admin/honor/edit",
    method: "post",
    data,
  });
}

/**
 * @description 荣誉删除
 * @param {Object} data - 荣誉删除参数
 * @param {number} data.id：荣誉ID - 荣誉ID
 * @returns {Promise} - 荣誉删除结果
 */
export function deleteWallHonor(data) {
  return service({
    url: "/service/admin/honor/delete",
    method: "post",
    data,
  });
}

/**
 * @description 荣誉项用户列表
 * @param {Object} data - 荣誉项用户列表参数
 * @param {number} data.page - 当前页
 * @param {number} data.pageSize：每页数量 - 每页数量
 * @returns {Promise} - 荣誉项用户列表结果  
*/
export function getWallHonorUserList(data) {
  return service({
    url: "/service/admin/honor/userList",
    method: "get",
    params: data,
  });
}

/**
 * @description 荣誉项新增用户
 * @param {Object} data - 荣誉项新增用户参数
 * @param {number} data.honor_id - 荣誉ID
 * @param {string} data.name：用户名 - 用户名
 * @param {string} data.idcard：身份证 - 身份证
 * @param {string} data.project：项目 - 项目
 * @param {string} data.grade：成绩 - 成绩
 * @param {string} data.date：时间 - 时间
 * @param {string} data.address：地址 - 地址
 * @param {string} data.group：分组 - 分组
 * @returns {Promise} - 荣誉项新增用户结果
 */
export function addWallHonorUser(data) {
  return service({
    url: "/service/admin/honor/userCreate",
    method: "post",
    params: data,
  });
}

/**
 * @description 荣誉项修改用户
 * @param {Object} data - 荣誉项修改用户参数
 * @param {number} data.id：荣誉项用户ID - 荣誉项用户ID
 * @param {number} data.honor_id - 荣誉ID
 * @param {string} data.name：用户名 - 用户名
 * @param {string} data.idcard：身份证 - 身份证
 * @param {string} data.project：项目 - 项目
 * @param {string} data.grade：成绩 - 成绩
 * @param {string} data.date：时间 - 时间
 * @param {string} data.address：地址 - 地址
 * @param {string} data.group：分组 - 分组
 * @returns {Promise} - 荣誉项修改用户结果
 */
export function editWallHonorUser(data) {
  return service({
    url: "/service/admin/honor/userEdit",
    method: "post",
    params: data,
  });
}

/**
 * @description 荣誉项用户删除
 * @param {Object} data - 荣誉项用户删除参数
 * @param {number} data.id：荣誉项用户ID - 荣誉项用户ID
 * @param {number} data.honor_id - 荣誉ID
 * @returns {Promise} - 荣誉项用户删除结果
 */
export function deleteWallHonorUser(data) {
  return service({
    url: "/service/admin/honor/userDelete",
    method: "post",
    params: data,
  });
}

/**
 * @description 导入荣誉项用户模板下载
 * @param {Object} data - 导入荣誉项用户模板下载参数
 * @param {number} data.honor_id - 荣誉ID
 * @returns {Promise} - 导入荣誉项用户模板下载结果
 */
export function downloadWallHonorUserTemplate(data) {
  return service({
    url: "/upfile/honor/比赛获奖名单导入模板.xls",
    method: "get",
    params: data,
    responseType: "blob",
  });
}

/**
 * @description 导入荣誉项用户
 * @param {Object} data - 导入荣誉项用户参数
 * @param {number} data.honor_id - 荣誉ID
 * @param {File} data.file：文件 - 文件
 * @returns {Promise} - 导入荣誉项用户结果
 */
export function importWallHonorUser(data) {
  return service({
    url: "/service/admin/honor/userImport",
    method: "post",
    params: data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}
